import move1 from '../img/move1.png'
import move2 from '../img/move2.png'
import move3 from '../img/move3.png'
import move4 from '../img/move4.png'
import moveImage from '../img/MenwithBoxPicture.png'
import rightArrow from '../img/rightArrow.svg'
import Btn from './Btn'
import { useEffect } from 'react'
export default function MoveBusiness(props) {
    const move = [
        {
            img: move1,
            title: "Junk Removel",
            des: 'With this new service, our professional moving teams can assist you with downsizing...'
        },
        {
            img: move2,
            title: "Storage",
            des: 'If you’re in between homes, completing home renovations, or just need a solution for items...'
        },
        {
            img: move3,
            title: "Long Distance Moving",
            des: 'Whether you’re moving across town or across the country, we’ll get you there...'
        },
        {
            img: move4,
            title: "Boxes & Supplies",
            des: 'Ensuring you have the right supplies and boxes to complete your next home or business move is crucial...'
        },
    ]

    return <>
    
    <div className='pt-0 pt-sm-5 move_business_sec' >
        <div className="movebusiness py-3 py-sm-5 mt-0 mt-lg-5" >
            <div className="container" >
                <div className="row">
                    <div className="col-lg-6">
                        <div className="move_content pt-3 pb-4 pb-sm-0" >
                            <h2>We Help You <br></br>MOVE Your Business Faster!
                                <svg width="194" height="36" viewBox="0 0 194 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.36782 6.73983C-1.70925 11.484 8.34876 13.1565 12.316 16.1058C18.9945 21.0688 27.8091 24.4995 37.3197 27.2952C57.3931 33.2029 79.2768 36.2733 103.273 35.723C120.401 35.3289 137.282 32.7489 153.39 26.699C167.468 21.4107 179.587 14.6673 189.37 6.3362C190.381 5.47474 191.256 4.55578 192.063 3.6307C192.553 3.06553 192.98 2.42279 193.069 1.83662C193.15 1.27772 193.303 0.443893 192.579 0.205202C191.856 -0.0334883 190.639 0.528489 189.867 0.877074C188.876 1.32392 188.059 1.94711 187.223 2.52577C182.917 5.50732 178.71 8.54921 174.314 11.4801C161.552 19.9937 146.407 25.3016 129.24 27.888C113.85 30.2098 98.8824 30.6045 84.3009 29.3229C66.64 27.771 50.1824 24.7271 35.783 19.0498C26.8261 15.5185 13.8008 5.53345 13.8008 5.53345C13.8008 5.53345 13.2724 4.98597 12.8842 4.6855C9.42971 2.01174 3.74783 3.07037 1.36782 6.73983Z" fill="#183B56" />
                                </svg>

                            </h2>
                            <p className='franchisetext' >Join the largest moving franchise in the United States. Our customers are so happy, they’re spreading the word. Launch your career with the growing moving franchise.</p>
                            <div className="d-flex flex-wrap mt-3 mt-sm-5 align-items-center" >
                                
                                <Btn class="btn bg-white mt-3 mt-md-0"
                                arrow={false}
                                wave={false}
                                href="#"
                            >See How its works ?</Btn>

                                <Btn class="nobg text-white  ms-0 ms-sm-3 mt-3 mt-md-0 d-flex"
                                arrow={false}
                                wave={false}
                                href="#"
                            >Get a free demo 
                            <img src={rightArrow} className="img-fluid ms-2" alt="image" /></Btn>



                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="menWithBox">
                            <img src={props && props.moveImg ? props.moveImg : moveImage} className="img-fluid" alt='image' />
                            <svg width="432" height="432" viewBox="0 0 432 432" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.15" fill-rule="evenodd" clip-rule="evenodd" d="M432 216C432 96.7065 335.294 0 216 0C96.7065 0 0 96.7065 0 216C0 335.294 96.7065 432 216 432C335.294 432 432 335.294 432 216ZM344 216C344 286.692 286.692 344 216 344C145.308 344 88 286.692 88 216C88 145.308 145.308 88 216 88C286.692 88 344 145.308 344 216Z" fill="url(#paint0_linear_1017_1045)" />
                                <defs>
                                    <linearGradient id="paint0_linear_1017_1045" x1="379.424" y1="390" x2="379.424" y2="-40.8484" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="white" stop-opacity="0.01" />
                                        <stop offset="1" stop-color="white" />
                                    </linearGradient>
                                </defs>
                            </svg>


                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="moveServ py-5" >
            <div className="container" >
                <div className="moveList" >
                    {move.map((m, i) => {
                        return <>
                            <div className="moveBox">
                                <div className="moveBoxImg">
                                    <div className="imgWrap" >
                                        <img src={m.img} className="img-fluid" alt="move" />
                                    </div>
                                </div>
                                <div className="moveBoxContent">
                                    <h2>{m.title}</h2>
                                    <p>{m.des}</p>
                                </div>
                            </div>
                        </>
                    })}
                </div>
            </div>
        </div>
    </div>
    </>
}